import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store/store";
import orgEdit from "@/views/org-edit.vue";
import axios from "axios";
import main from "@/views/main-page.vue";
import pointEdit from "@/views/point-edit.vue";
import wasteTypeEdit from "@/views/wasteType-edit.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "main",
    component: main,
    meta: {
      permission: "",
      requiresAuth: false,
    },
  },
  {
    path: "/edit-org/:id",
    name: "edit-org",
    component: orgEdit,
    meta: {
      permission: "wasteMap:org:r",
      requiresAuth: true,
    },
  },
  {
    path: "/edit-org",
    name: "edit-org",
    component: orgEdit,
    meta: {
      permission: "wasteMap:org:r",
      requiresAuth: true,
    },
  },
  {
    path: "/edit-point/:id",
    name: "edit-point",
    component: pointEdit,
    meta: {
      permission: "wasteMap:point:r",
      requiresAuth: true,
    },
  },
  {
    path: "/edit-point",
    name: "edit-point",
    component: pointEdit,
    meta: {
      permission: "wasteMap:point:r",
      requiresAuth: true,
    },
  },
  {
    path: "/edit-waste-type/:id",
    name: "edit-waste-type",
    component: wasteTypeEdit,
    meta: {
      permission: "wasteMap:wasteType:c",
      requiresAuth: true,
    },
  },
  {
    path: "/edit-waste-type",
    name: "edit-waste-type",
    component: wasteTypeEdit,
    meta: {
      permission: "wasteMap:wasteType:c",
      requiresAuth: true,
    },
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../views/login-page.vue"),
    meta: {
      permission: "",
      requiresAuth: false,
    },
  },
  {
    path: "/registration",
    name: "registration",
    component: () => import("../views/registration-page.vue"),
    meta: {
      permission: "",
      requiresAuth: false,
    },
  },
  {
    path: "/access-is-denied",
    name: "access-is-denied",
    component: () => import("../views/noPerm-page.vue"),
    meta: {
      permission: "",
      requiresAuth: false,
    },
  },
];

const router = new VueRouter({
  routes,
});

router.beforeEach(async (to, from, next) => {
  // если нет авторизации, получить ее по куки
  if (!store.getters.isLoggedIn) {
    await axios
      .post("/api/auth/check-auth")
      .then((resp) => {
        store.commit("auth_success", resp.data);
      })
      .catch(() => {});
  }
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      if (to.meta.permission === "") {
        next();
        return;
      }
      checkPermission(store.getters.permissions, to.meta.permission)
        .then(() => {
          next();
        })
        .catch(() => {
          next({ name: "access-is-denied" });
        });
      return;
    }
    next("/login");
  } else {
    next();
  }
});

function checkPermission(permissions, toPerm) {
  return new Promise((resolve, reject) => {
    if (permissions.indexOf(toPerm) !== -1) {
      resolve("");
    } else {
      reject("err");
    }
  });
}

export default router;
